<footer>
    <div class="footer-links">
        <div class="footer-item"><a href="/home">Map The Day, LLC</a></div>
        <div class="footer-item"><a href="/about">About Us</a></div>
        <div class="footer-item"><a href="/contact-us">Contact Us</a></div>
        <div class="footer-item"><a href="/terms-of-service">Terms of Service</a></div>
        <div class="footer-item"><a href="/privacy-policy">Privacy Policy</a></div>
        <div class="footer-item"><a href="/terms-of-service">Copyright © 2025</a></div>
    </div>
</footer>

<style>
footer {
    padding: 1.5rem 1rem;
    width: 100%;
}

.footer-links {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 1rem;
    max-width: 1200px;
    margin: 0 auto;
}

.footer-item {
    position: relative;
    padding: 0 0.5rem;
}

.footer-item:not(:last-child)::after {
    content: "•";
    position: absolute;
    right: -0.5rem;
    color: #ccc;
}

.footer-links a {
    text-decoration: none;
    font-size: 0.9rem;
    color: inherit;
    transition: opacity 0.2s ease;
}

.footer-links a:hover {
    opacity: 0.7;
}

@media (max-width: 768px) {
    .footer-links {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 1.5rem;
        width: 100%;
        text-align: center;
        padding: 0 1rem;
    }

    .footer-item {
        padding: 0;
    }

    .footer-item:not(:last-child)::after {
        display: none;
    }
}

@media (max-width: 380px) {
    .footer-links {
        grid-template-columns: 1fr;
        gap: 1rem;
    }

    .footer-item:last-child {
        margin-top: 0.5rem;
    }
}
</style>